import { useEffect } from 'react';
import { useLocation } from 'react-router';
import {
  getPageSeo,
  DEFAULT_TITLE,
  DEFAULT_DESCRIPTION,
  isPrivateSeoPath,
  isNoindexPublicPath,
} from '../util/seoConfig';
import { applyPageHeadMeta } from '../util/pageMetaDom';
import { injectPageJsonLd, jsonLdForPath, removePageJsonLd } from '../util/seoStructuredData';

/**
 * Updates document.title, meta description, canonical, Open Graph, Twitter tags,
 * and page JSON-LD on route change for public SEO pages.
 */
export function PageMeta() {
  const location = useLocation();

  useEffect(() => {
    const privatePath = isPrivateSeoPath(location.pathname);
    const noindexPublic = isNoindexPublicPath(location.pathname);
    const seo = privatePath && !noindexPublic ? null : getPageSeo(location.pathname, location.search);
    const indexable = !privatePath && !noindexPublic && seo !== null;
    const title = noindexPublic
      ? DEFAULT_TITLE
      : (seo?.title ?? DEFAULT_TITLE);
    const description = noindexPublic
      ? DEFAULT_DESCRIPTION
      : (seo?.description ?? DEFAULT_DESCRIPTION);
    const robots = indexable ? null : 'noindex, nofollow';
    const canonicalPath = noindexPublic ? '/' : null;

    applyPageHeadMeta(title, description, location.pathname, robots, canonicalPath);

    removePageJsonLd();
    if (privatePath) return;

    const pageLd = jsonLdForPath(location.pathname, location.search);
    if (pageLd) {
      injectPageJsonLd(pageLd);
    }
  }, [location.pathname, location.search]);

  return null;
}
